export default "__VITE_ASSET__XlQg0Kjj__"